export const addOptimisticItem = (product, quantity) => ({
  type: 'ADD_OPTIMISTIC_ITEM',
  payload: {
    productId: product,
    quantity
  }
});

export const clearOptimisticItems = () => ({
  type: 'CLEAR_OPTIMISTIC_ITEMS'
}); 